import React, { useEffect } from 'react';

import useMediaQuery from '@mui/material/useMediaQuery';
import { Controller, UseFormReturn } from 'react-hook-form';
import scssVariables from 'styles/variables.module.scss';

import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import { FiltersStatus } from 'components/common/GlobalFiltersInPage/GlobalFiltersInPage';
import SearchByNameClasses from 'components/common/GlobalFiltersInPage/components/searchByNameFilter/SearchByNameFilter.module.scss';
import { AdvancedWrapperTooltipContent } from 'components/common/GlobalFiltersInPage/components/searchByNameFilter/components/AdvancedWrapperTooltipContent/AdvancedWrapperTooltipContent';
import { signalSingleFilterIsReady } from 'components/common/GlobalFiltersInPage/hooks/useSubscribersFiltersReady';
import Icon from 'components/common/Icons/base/Icon/Icon';

import { IActivityType } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { Switch } from 'components/DesignSystem/Switch';
import { TextInput } from 'components/DesignSystem/TextInput';
import { CustomizedRoundIcon, CustomizedTooltip } from 'components/common';

interface Props {
    methods?: UseFormReturn<any, any>;
    name: string;
    filtersStatusRef?: React.MutableRefObject<FiltersStatus>;
    handleFilters?: () => void;
    value?: IActivityType[];
    isSelected?: boolean;
}

export const SearchByNameFilter = ({
    name,
    methods,
    filtersStatusRef,
    handleFilters,
    value,
    isSelected = true,
}: Props) => {
    const { mediaLaptop } = scssVariables;
    const isLaptop = useMediaQuery(`(max-width: ${mediaLaptop})`);

    useEffect(() => {
        if (!filtersStatusRef?.current || filtersStatusRef?.current[name]?.isReady) {
            return;
        }

        signalSingleFilterIsReady({ filterId: name, isReady: true });
    }, [value, name, filtersStatusRef]);

    return isSelected ? (
        <div className={SearchByNameClasses.container}>
            <div
                data-testid={'battlecards-filters-card-search'}
                className={`${SearchByNameClasses.selectWrapper} ${SearchByNameClasses.textSearchInputWrapper}`}
            >
                <Controller
                    render={({ field }) => (
                        <TextInput
                            id={'battlecards-filters-card-search'}
                            {...field}
                            value={methods?.watch(name)?.value ?? ''}
                            onChange={(e) => {
                                const data = methods?.watch(name);
                                methods?.setValue(name, { ...data, value: e.currentTarget.value });
                                handleFilters?.();
                            }}
                            placeholder={'Search by name or Id...'}
                            onClear={() => {
                                methods?.setValue(name, null);
                                handleFilters?.();
                            }}
                            maxLength={300}
                        />
                    )}
                    name={name}
                    control={methods?.control}
                />

                <div className={SearchByNameClasses.advancedWrapper}>
                    <Switch
                        checked={
                            methods?.watch(name)?.isAdvancedTextSearch
                                ? methods?.watch(name)?.isAdvancedTextSearch
                                : false
                        }
                        onChange={() => {
                            const data = methods?.watch(name);
                            methods?.setValue(name, {
                                ...data,
                                isAdvancedTextSearch: !methods?.watch(name)?.isAdvancedTextSearch,
                            });
                            handleFilters?.();
                        }}
                        label={'Advanced'}
                    />

                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Bottom}
                        contentStyles={{
                            maxWidth: isLaptop ? '400px' : '650px',
                        }}
                        key={'advancedInfo'}
                        tooltipContent={<AdvancedWrapperTooltipContent />}
                        triggerElement={
                            <CustomizedRoundIcon enableHover={true} size={'24px'}>
                                <Icon name={'info-icon'} size={'14'} />
                            </CustomizedRoundIcon>
                        }
                    />
                </div>
            </div>
        </div>
    ) : null;
};
